const updates = [
  { time: '10分钟前', tag: '独家', title: '某顶流被曝与经纪人亲密同行，疑似恋情浮出水面', tagColor: 'bg-primary-500' },
  { time: '28分钟前', tag: '热搜', title: '热门综艺节目组内部邮件泄露，嘉宾名单提前曝光', tagColor: 'bg-accent-500' },
  { time: '1小时前', tag: '快讯', title: '知名女星发文暗示离婚，粉丝涌入评论区炸开锅', tagColor: 'bg-secondary-500' },
  { time: '2小时前', tag: '独家', title: '某男团成员深夜出入酒吧被拍，经纪公司紧急公关', tagColor: 'bg-primary-500' },
  { time: '3小时前', tag: '深挖', title: '影视圈"阴阳合同"再现？业内人士爆料惊人细节', tagColor: 'bg-accent-500' },
  { time: '4小时前', tag: '热搜', title: '网红主播直播间翻车，口误说出品牌方底价引发轩然大波', tagColor: 'bg-secondary-500' },
  { time: '5小时前', tag: '快讯', title: '某选秀节目导演被爆潜规则选手，节目组回应称纯属造谣', tagColor: 'bg-primary-500' },
  { time: '6小时前', tag: '独家', title: '当红小花旦深夜发博秒删，疑似回应近期争议', tagColor: 'bg-accent-500' },
  { time: '8小时前', tag: '深挖', title: '某娱乐公司股权变更背后：资本对赌的暗流涌动', tagColor: 'bg-secondary-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时更新，不错过任何一条瓜</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-primary-600">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>
        <div className="space-y-0">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-3 md:gap-4 py-3.5 border-b border-background-200/70 last:border-b-0 hover:bg-background-50/80 px-3 -mx-3 rounded-md transition-colors cursor-pointer"
            >
              <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5 min-w-[60px]">
                {item.time}
              </span>
              <span className={`px-2 py-0.5 rounded text-[10px] font-medium text-background-50 whitespace-nowrap ${item.tagColor} flex-shrink-0`}>
                {item.tag}
              </span>
              <span className="text-sm text-foreground-800 leading-relaxed hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </span>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <a
            href="#carousel"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}